export const COMPONENT_IDS = {
  COMMON_MODAL: "modal",
  COMMON_MODAL_TITLE: "modal-title",
  COMMON_MODAL_PRIMARY_BTN: "modal-primary-button",
  COMMON_MODAL_SECONDARY_BTN: "modal-secondary-button",
  COMMON_MODAL_TERTIARY_BTN: "modal-tertiary-button",
  COMMON_MODAL_FOOTER_ERROR: "modal-footer-error",
  COMMON_TABLE_NO_RESULT: "no-result",
  COMMON_ACCORDION_INDIVIDUAL: "accordion-individual",
  COMMON_ACCORDION_REMOVE_ICON: "accordion-remove-icon",
  COMMON_ACCORDION_ADD_ICON: "accordion-add-icon",
  COMMON_ACCORDION_HEADER_TEXT: "accordion-header-text",
  COMMON_DOUBLE_LABEL: "double-label",
  COMMON_DOUBLE_LABEL_VALUE: "double-label-value",
  COMMON_TRIPLE_LABEL: "triple-label",
  COMMON_TRIPLE_LABEL_MAIN_VALUE: "triple-label-main-value",
  COMMON_TRIPLE_LABEL_SUB_VALUE: "triple-label-sub-value",
  ERROR_INFO_ICON: "error-info-icon",
  COMMON_MODAL_CLOSE_ICON: "modal-close-icon",
  EXPAND_COLLAPSE_BUTTON: "expand-collapse-button",
  CONTINUE_BUTTON: "continue-button",
  SAVE_BUTTON: "save-button",
  CANCEL_BUTTON: "cancel-button",
  CLOSE_BUTTON: "close-button",
  TAG_PARENT_BUTTON: "tag-parent-button",
  REMOVE_PARENT_BUTTON: "remove-parent-button",
  TAG_PARENT_MODAL: "tag-parent-modal",
  INHERIT_DOCUMENTS_MODAL: "inherit-documents-modal",
  ADD_GOAL_MODAL: "add-goal-modal",
  VIEW_GOAL_MODAL: "view-goal-modal",
  ADD_EXISTING_PROGRAMS_MODAL: "add-existing-programs-modal",
  CONFIRMATION_MODAL: "confirmation-modal",
  INFORMATION_MODAL: "information-modal",
  COPY_TO_CLIPBOARD: "copy-to-clipboard",
  COMMON_TABLE_NAME: "table-name",
  COMMON_OPTION_MENU: "option-menu",
  COMMON_OPTION_MENU_DELETE: "option-menu-delete",
  COMMON_OPTION_MENU_EDIT: "option-menu-edit",
  COMMON_OPTION_MENU_UNMAP: "option-menu-unmap",
  OPTION_MENU_CANCEL_CONTRACT: "option-menu-cancel-contract",
  OPTION_MENU_MARK_AS_ACTIVE: "option-menu-mark-as-active",
  OPTION_MENU_MARK_AS_EXPIRED: "option-menu-mark-as-expired",
  OPTION_MENU_MARK_AS_ARCHIVE: "option-menu-mark-as-archive",
  COMMON_DATE_PICKER_FORM_CONTROLLER: "date-picker-form-controller",
  COMMON_DATE_TIME_PICKER_FORM_CONTROLLER: "date-time-picker-form-controller",
  COMMON_DATE_PICKER: "date-picker",
  COMMON_HEADER_ACTION_BUTTON: "header-action-button",
  COMMON_VIEW_LINK: "view-link",
  UPDATE_BUTTON: "update-button",
  BILLING_CONFIGURATION_ADD_BUTTON: "billing-configuration-add-button",
  VIEW_PROGRAM_FEE_MODAL: "view-program-fee-modal",
  COMMON_MODAL_ACTION_BTN: "modal-action-button",
  REVENUE_SPLIT_MODAL: "revenue-split-modal",
  VIEW_INVOICE_MODAL: "view-invoice-modal",
  EDIT_BUTTON: "edit-button",
  ADD_NEW_CONTACT_MODAL: "add-new-contact-modal",
  REMOVE_PARENT_MODAL: "remove-parent-modal",
  MENU_POPPER: "menu-popper",
  SAVE_FILTER_MODAL: "save-filter-modal",
  ARROW_DOWNWARD_ICON: "arrow-downward-icon",
  ARROW_UPWARD_ICON: "arrow-upward-icon",
  TABLE_HEADER_SEARCH_ICON: "table-header-search-icon",
};
